import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService, UserRole } from '@libs/core/auth-pt';

export const DriverGuard = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  return authService.currentRole$.pipe(
    map((role) => {
      switch (role) {
        case UserRole.Carrier:
          return router.createUrlTree(['packages/carrier']);
        case UserRole.Driver:
          return true;
        default:
          return false;
      }
    }),
  );
};

export const CarrierGuard = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  return authService.currentRole$.pipe(
    map((role) => {
      switch (role) {
        case UserRole.Carrier:
          return true;
        case UserRole.Driver:
          return router.createUrlTree(['packages/driver']);
        default:
          return false;
      }
    }),
  );
};
